import { render, staticRenderFns } from "./ARazonesrecibos.vue?vue&type=template&id=7bde18fa"
import script from "./ARazonesrecibos.vue?vue&type=script&lang=js"
export * from "./ARazonesrecibos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports